import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, Columns3, Sparkles, ChevronDown } from "lucide-react";
import { api } from "../../lib/api";
import { StickyBack } from "../../components/StickyBack";
import CrmBoard from "../../components/crm/CrmBoard";

const STEPS = [
  ["1. Ajoute ton prospect", "Dès que tu envoies ton premier message ou audio, crée une carte avec son @ Instagram. Elle arrive dans « Contacté »."],
  ["2. Laisse les automatisations travailler", "2 jours après, la carte passe toute seule dans « À relancer (1ère relance) ». Après chaque relance faite, elle repasse automatiquement en « À relancer » 4 jours plus tard."],
  ["3. Relance, puis glisse la carte", "Les colonnes « À relancer » en bordeaux te montrent qui relancer aujourd'hui. Envoie ta relance, puis glisse la carte dans la colonne « relance faite ✅ » correspondante."],
  ["4. Mets à jour la suite", "Appel booké : « Appel réservé ». Absent à l'appel : « No-show ». Client signé : « Closé », avec le montant. Pas de réponse après la 3ème relance : « Abandonné »."],
];

function CrmIntro() {
  const [open, setOpen] = useState(false);
  return (
    <div data-testid="crm-intro" className="rounded-[24px] border border-line bg-white shadow-card">
      <button type="button" data-testid="crm-intro-toggle" onClick={() => setOpen(!open)} className="flex w-full items-center justify-between gap-3 p-5 text-left sm:px-6">
        <span className="flex items-center gap-2.5 font-sans text-base font-medium text-ink"><Sparkles size={17} className="text-bordeaux" /> Comment fonctionne ton CRM</span>
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cream"><ChevronDown size={16} className={`text-bordeaux transition-transform ${open ? "rotate-180" : ""}`} /></span>
      </button>
      {open && <div data-testid="crm-intro-content" className="border-t border-line p-5 sm:px-6">
      <p className="mt-2 text-sm font-light text-ink-soft">Ton CRM fait le suivi à ta place : les cartes changent de colonne automatiquement selon les délais de relance. Ton seul travail est de le tenir à jour chaque jour.</p>
      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(([t, d]) => (
          <div key={t} className="rounded-2xl bg-cream p-4">
            <p className="text-sm font-medium text-ink">{t}</p>
            <p className="mt-1 text-xs font-light leading-relaxed text-ink-soft">{d}</p>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-ink-muted">Sur téléphone : appuie longuement sur une carte pour la glisser. Un simple clic ouvre sa fiche.</p>
      </div>}
    </div>
  );
}

export default function HubCrm() {
  const navigate = useNavigate();
  const [locked, setLocked] = useState(null);
  useEffect(() => {
    api.get("/client/hub-pages").then(({ data }) => setLocked(!!data.crm_locked)).catch(() => setLocked(true));
  }, []);
  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="space-y-8">
      <StickyBack onClick={() => navigate("/espace/hub")}>Revenir à The Elevate Hub</StickyBack>
      <div className="flex items-start gap-4">
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-bordeaux text-white shadow-[0_8px_24px_rgba(123,17,58,0.35)]"><Columns3 size={26} /></span>
        <div>
          <h1 className="font-sans text-2xl font-medium text-ink sm:text-4xl">Ton CRM de setting</h1>
          <p className="mt-1 text-sm font-light text-ink-muted">Suis chaque prospect, tes relances et tes ventes au même endroit.</p>
        </div>
      </div>
      {locked === true && <div data-testid="crm-locked" className="flex items-center gap-3 rounded-2xl border border-line bg-white p-6 text-ink-muted"><Lock size={18} /> Cette ressource n'est pas encore disponible.</div>}
      {locked === false && <CrmIntro />}
      {locked === false && <CrmBoard />}
    </motion.div>
  );
}
